var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-center"},[_c('VueApexCharts',{attrs:{"type":"pie","options":{
      chartOptions: _vm.chartOptions,
      labels: _vm.labels,
      colors: _vm.colors,
      legend: {
        show: true,
        showForSingleSeries: false,
        showForNullSeries: true,
        showForZeroSeries: true,
        position: 'bottom',
        horizontalAlign: 'center',
        itemMargin: {
          horizontal: 5,
          vertical: 0,
        },
      },
    },"series":_vm.series,"width":" 300"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }